import React from "react";

import {
  generateCalendarDayHeader,
  NumericalDayOfWeek,
} from "@whoosh/utilities/src/calendars";

import { Box, HStack, Text } from "../../../primitive";

export const MonthHeader = ({
  clubWeekStartsOn,
}: {
  clubWeekStartsOn: NumericalDayOfWeek;
}) => {
  const dayNames = generateCalendarDayHeader(clubWeekStartsOn);
  return (
    <HStack justifyContent="space-between">
      {dayNames.map((name) => {
        return (
          <Box
            key={name}
            alignItems="center"
            justifyContent="center"
            width={{ base: 36, xs: 40 }}
            height={{ base: 36, xs: 40 }}
          >
            <Text color="text-secondary" variant="mainMicro" textAlign="center">
              {name}
            </Text>
          </Box>
        );
      })}
    </HStack>
  );
};
